<div class="form-group col-sm-12">
  <label>Address<sup class='required-star'></sup></label>

  <gmp-place-autocomplete
    #placesWrapper="appGooglePlacesAutocomplete"
    appGooglePlacesAutocomplete
    class="form-control address"
    placeholder="Enter address"
    requested-fields="addressComponents,location,id,timeZone"
    (addressChange)="onPlaceChange($event)"
    (inputChange)="addressGoogleInputChange($event)"
  ></gmp-place-autocomplete>

  <div class='text-danger' *ngIf='_validate && !addressGoogleInputValue'>The field is required</div>
</div>

<div *ngIf="!!model" class="address-fields">
  <div class="row">
    <div class="form-group col-sm-6" [class.has-error]="state | hasErrors: _validate">
      <label>State<sup class='required-star'></sup></label>
      <input
        type="text"
        name="stateName"
        class="form-control"
        [(ngModel)]="model.UState"
        #state="ngModel"
        [disabled]="stateDisabled"
        required
      />
      <app-validation-errors [model]="state" [validate]="_validate"></app-validation-errors>
    </div>

    <div class="form-group col-sm-6" [class.has-error]="street | hasErrors: _validate">
      <label>Street<sup class='required-star'></sup></label>
      <input
        type="text"
        name="streetName"
        class="form-control"
        [(ngModel)]="model.Street"
        #street="ngModel"
        [disabled]="streetDisabled"
        required
      />
      <app-validation-errors [model]="street" [validate]="_validate"></app-validation-errors>
    </div>
  </div>

  <div class="row" style='margin-top: 10px'>
    <div class="form-group col-sm-6" [class.has-error]="city | hasErrors: _validate">
      <label>City<sup class='required-star'></sup></label>
      <input type="text" name="cityName" class="form-control" [(ngModel)]="model.City" #city="ngModel" [disabled]="cityDisabled" required />
      <app-validation-errors [model]="city" [validate]="_validate"></app-validation-errors>
    </div>

    <div class="form-group col-sm-6" [class.has-error]="zip | hasErrors: _validate">
      <label>Zip Code<sup class='required-star'></sup></label>
      <input type="text" name="zipName" class="form-control" [(ngModel)]="model.Zip" #zip="ngModel" [disabled]="zipDisabled" required />
      <app-validation-errors [model]="zip" [validate]="_validate"></app-validation-errors>
    </div>
  </div>
</div>
